import {
  Collection,
  CollectionBranch,
  CollectionTrunk,
  Experience,
  ServerExperience,
} from "./interfaces";
import allDataFromServer from "../../data/all-data-2025-04-09.json";
import thumbnails from "../../data/thumbnails.json";
import collectionTrunks from "../../data/collections.json";
import JMC_Logo from "../../assets/svg-logos/Hor_Asset-2JMC_Logo.svg";
import JHT_Logo from "../../assets/svg-logos/Jacuzzi_HotTubs_Logo_Black.svg";
import JIS_Logo from "../../assets/svg-logos/Hor_Asset-2JSauna_Logo.svg";
import SDS_Logo from "../../assets/svg-logos/SDS_Logo_Blue.svg";
import JSS_Logo from "../../assets/svg-logos/Hor_JSS_Logo.svg";
import SDSS_Logo from "../../assets/svg-logos/SDSS_Logo_Blue.svg";
import SNS_Logo from "../../assets/svg-logos/SNS_Logo_Blue.svg";

export const getLogoSvgOrUrl = (companyName: string): string => {
  const root = "/img/logos/";
  if (/jacuzzi-hot/i.test(companyName)) {
    return JHT_Logo;
  } else if (/sun-and-soul/i.test(companyName)) {
    return SNS_Logo;
  } else if (/jacuzzi-swim/i.test(companyName)) {
    return JSS_Logo;
  } else if (/dimension/i.test(companyName)) {
    return `${root}dimension-one-spas.png`;
  } else if (/sundance-swim/i.test(companyName)) {
    return SDSS_Logo;
  } else if (/sundance/i.test(companyName)) {
    return SDS_Logo;
  } else if (/chairs/i.test(companyName)) {
    return JMC_Logo;
  } else if (/saunas/i.test(companyName)) {
    return JIS_Logo;
  }
  return "";
};

export const filterListingBySearch = (
  data: Experience[],
  search: string,
): Experience[] => {
  const sortedData = data.sort((a: Experience, b: Experience): number =>
    a.year > b.year ? -1 : 1,
  );
  if (search) {
    const searchable = new RegExp(`${search}`, "i");
    return sortedData.filter((e: Experience): boolean =>
      searchable.test(e.name),
    );
  }
  return sortedData;
};

export const getCollection = (thumbData: any, vendorName: string): string => {
  if (!thumbData) {
    return "Other";
  }
  if (vendorName === "sundance-swim-spas" && /swimspa/i.test(thumbData.name)) {
    return 'swimspa';
  }
  // Jacuzzi
  if (/power|j-1\d/i.test(thumbData.name)) {
    return 'power|j-1\\d';
  }
  if (/j-2/i.test(thumbData.name)) {
    return 'j-200';
  }
  if (/j-3/i.test(thumbData.name)) {
    return 'j-300';
  }
  if (/j-4/i.test(thumbData.name)) {
    return 'j-400';
  }
  if (/j-5/i.test(thumbData.name)) {
    return 'j-500';
  }
  if (/j-l/i.test(thumbData.name)) {
    return 'j-l';
  }
  if (/play/i.test(thumbData.name)) {
    return 'play';
  }

  // Sun & Soul
  if (/soulnova/i.test(thumbData.name)) {
    return 'soulnova';
  }
  
  // Dimension 1
  if (/[34] person/i.test(thumbData.name)) {
    return '34 person';
  }
  if (/[56] person/i.test(thumbData.name)) {
    return '56 person';
  }
  if (/[789] person/i.test(thumbData.name)) {
    return '7 person';
  }
  
  // Sundance
  if (/680/i.test(thumbData.name)) {
    return '680';
  }
  if (/780/i.test(thumbData.name)) {
    return '780';
  }
  if (/880/i.test(thumbData.name)) {
    return '880';
  }
  if (/980/i.test(thumbData.name)) {
    return '980';
  }
  if (/splash/i.test(thumbData.name)) {
    return 'splash';
  }
  return "Other";
}

export const getListingByCompany = (vendorName: any): Experience[] => {
  return allDataFromServer
    .filter(({ vendor }: ServerExperience): boolean => vendor === vendorName)
    .map(({ id, publicName, textures, vendor }: ServerExperience): Experience => {
      const nameFiltering = /(Sundance(\s+Spas)?|Jacuzzi|D1)\s+([a-z0-9 -]+)(\d{4}$)?/i.exec(publicName);
      const thumb = thumbnails.find((t: any): boolean => t.id === id);
      console.log(publicName, nameFiltering);
      const extraYear = nameFiltering ? /([a-z0-9 -()]+)(\d{4}$)/i.exec(nameFiltering[3]) : undefined;
      const year = extraYear ? extraYear[2] : thumb ? thumb.year : 2022;
      const spaName = nameFiltering ? nameFiltering[3].replace(/(\s202\d|NEW)$/, '') : extraYear ? extraYear[1].replace('NEW', '') : publicName;
      return {
        id,
        name: `${spaName} (${year})`,
        year: year as number,
        thumbnail:
          thumb ? thumb.thumbnail as string : "",
        textures,
        collection: getCollection(thumb, vendorName),
        vendor,
      };
    });
};

export const getSingleExperience = (
  vendor: any,
  id: any,
): Experience | undefined => {
  const companyData = getListingByCompany(vendor);
  if (companyData) {
    return companyData.find((e: Experience): boolean => id === e.id);
  }
  return undefined;
};

export const getHumanCompanyName = (vendor: any): string => {
  if (typeof vendor === "string") {
    if (vendor === "sun-and-soul-spas") {
      return "Sun & Soul Spas"
    }
    return vendor
      .split("-")
      .map((particle: string): string => {
        return `${particle.slice(0, 1).toUpperCase()}${particle.slice(1)}`;
      })
      .join(" ");
  }
  return "";
};

export const getSpreadsheetURL = (vendor: any): string => {
  if (vendor === "jacuzzi-hot-tubs") {
    return "https://docs.google.com/spreadsheets/d/1fNCoTYNaw1fsFKlAKMZtu8nJCo59UMo3cwmLpa7M57o/edit?usp=sharing";
  }
  if (vendor === "jacuzzi-swim-spas") {
    return "https://docs.google.com/spreadsheets/d/12laF-UWi5A5xsAAQei20lbBjmRQlYX6B2zrg6_-EXb4/edit?usp=sharing";
  }
  if (vendor === "dimension-one-spas") {
    return "https://docs.google.com/spreadsheets/d/172G3h2QKVbk64d4m6MtJsBjQj9KWmx0vj8XkVKEbGZ8/edit?usp=sharing";
  }
  if (vendor === "sundance-spas" || vendor === "sundance-swim-spas") {
    return "https://docs.google.com/spreadsheets/d/1kh8qZoekiO5xasm7sKfdaYrRNgeCFtJmX43juAop3qc/edit?usp=sharing";
  }
  return "#";
};

export const getCollectionTrunk = (vendor: string): CollectionTrunk | null => {
  if (Object.hasOwn(collectionTrunks, vendor)) {
    const descriptor = Object.getOwnPropertyDescriptor(
      collectionTrunks,
      vendor,
    );
    if (descriptor) {
      return descriptor.value as CollectionTrunk;
    }
  }
  return null;
};

export const buildRemainingListing = (
  title: string,
  experiences: Experience[],
): Collection[] => {
  return [
    {
      title,
      experiences,
    },
  ];
};

export const getCollectedListing = (vendor: any): Collection[] => {
  const plainListing = getListingByCompany(vendor);
  if (plainListing.length) {
    const cTrunk = getCollectionTrunk(vendor);
    if (cTrunk && cTrunk.collected) {
      const idRegistry: string[] = [];
      const collectedExperiences = cTrunk.collections.map(
        (definition: CollectionBranch): Collection => {
          const matcher = new RegExp(definition.matcher, "i");
          return {
            title: definition.title,
            experiences: plainListing.filter((e: Experience): boolean => {
              if (matcher.test(e.collection)) {
                idRegistry.push(e.id);
                return true;
              }
              return false;
            }),
          };
        },
      );
      collectedExperiences.push({
        title: "Other",
        experiences: plainListing.filter(
          (e: Experience): boolean => !idRegistry.includes(e.id),
        ),
      });
      return collectedExperiences;
    }
  }
  return buildRemainingListing("Other", plainListing);
};
